<template>
        <img
            v-if="thumbnail"
            :src="thumbnail"
            class="file-thumbnail"
            alt="thumbnail"
            :data-id="item.id"
        />

        <div v-else v-html="createSkeletonThumbnail"></div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "Thumbnail",
    data() {
        return {
            thumbnail: null
        }
    },
    props: {
        item: Object,
        inComments: Boolean,
    },

    async created() {
        if (!this.item) return;
        await this.loadThumbnail();
    },

    mounted() {
        if (!this.item) return;
        if (!this.inComments) return;
        // if (!this.thumbnail) return;

        setTimeout(() => {
            this.thumbnail = this.fileThumbnailObjects[this.item.id];
        }, 5000)
    },

    computed: {
        ...mapState("Projects", ["project_id", "fileThumbnailObjects"]),

        createSkeletonThumbnail() {
            return window.UI.createFileThumbnailPlaceholder();
        },
    },

    methods: {
        async loadThumbnail() {
            if (!this.fileThumbnailObjects[this.item.id]) {
                let thumbnailData = await this.$store.dispatch('Projects/fetchThumbnail', {
                    file: this.item,
                    project_id: this.project_id
                });

                this.thumbnail = URL.createObjectURL(thumbnailData.blob);

                let thumbnailObject = {
                    file_id: this.item.id,
                    objectURL:  this.thumbnail
                };

                this.$store.dispatch('Projects/setThumbnailObject', thumbnailObject);
            } else {
                this.thumbnail = this.fileThumbnailObjects[this.item.id];
            }
        }
    }
}
</script>

<style scoped>

</style>